import { OsCorrespondanceService } from './../os-correspondance.service';
import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { OsCorrespondance } from '../../models/OsCorrespondance';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatCard, MatCardModule } from '@angular/material/card';
import {
  MatCardHeader,
  MatCardTitle,
} from '../../../../node_modules/@angular/material/card/index';
import { MatFormFieldModule } from '@angular/material/form-field';
import { h } from '../../../../node_modules/@angular/material/module.d-CyLvt0Fz';
import { Type } from '../../models/Type';
import { M } from "../../../../node_modules/@angular/material/option.d-BVGX3edu";
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-create-os-correspondance',
  imports: [
    CommonModule,
    MatCardModule,
    MatFormFieldModule,
    FormsModule,
    MatInputModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatButtonModule,
    MatDialogModule
],
  templateUrl: './create-os-correspondance.component.html',
  styleUrl: './create-os-correspondance.component.css',
})
export class CreateOsCorrespondanceComponent implements OnInit{
  osCorrespondance: OsCorrespondance = new OsCorrespondance();
  types: Type[] = [];
  selectedType?: Type;
  osCorrespondanceForm: FormGroup;
  updateStatus: boolean = false;

  @Output() createOsCorrespondanceEmit = new EventEmitter<OsCorrespondance>();

  @Output() updateOsCorrespondanceEmit = new EventEmitter<OsCorrespondance>();

  constructor(
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public osCorrespondanceService: OsCorrespondanceService
  ) {
    this.osCorrespondanceForm = this.formBuilder.group({
      idOsCorrespondance: [null, []],
      isDeleted: [false, []],
      nomOs: ['', Validators.required],
      type: [null, Validators.required],
    });


  }

  ngOnInit(): void {
    this.osCorrespondanceService.getAllType().subscribe(result => {
      this.types = result;
      if (this.data) {
        this.updateStatus = true;
        const os: OsCorrespondance = this.data.osCorrespondance;
        this.osCorrespondanceForm.patchValue({
          idOsCorrespondance: os.idOsCorrespondance ?? null,
          isDeleted: os.isDeleted ?? false,
          nomOs: os.nomOs ?? '',
          type: os.type?.code ?? null, 
        });
      }
    })
  }

  public formSubmit() {
    debugger
    const rowValue = this.osCorrespondanceForm.getRawValue();
    this.osCorrespondance.idOsCorrespondance = rowValue.idOsCorrespondance;
    this.osCorrespondance.isDeleted = rowValue.isDeleted;
    this.osCorrespondance.nomOs = rowValue.nomOs;
    this.osCorrespondance.type = new Type();
    this.osCorrespondance.type.code = rowValue.type;

    if (!this.updateStatus) {
      this.createOsCorrespondanceEmit.emit(this.osCorrespondance);
    } else {
      this.updateOsCorrespondanceEmit.emit(this.osCorrespondance);
    }
  }
}
